const apiRoutes = {
  Locks: 'locks',
};


export default apiRoutes;



// WEBPACK FOOTER //
// ./src/config/apiRoutes.js